<oui-date-picker
  label="Date de début de validité"
  placeholder="JJ/MM/AAAA"
  [control]="form.get('dateDebutValidite')"
  [errors]="dateValidationErrors"
  (valueChange)="setDateFinDeValidite($event)"></oui-date-picker>
